export const innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.75" y="3.75" width="16.5" height="16.5" rx="1.25" stroke="currentcolor" stroke-width="1.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.1001 20V4H12.9001V20H11.1001Z" fill="currentcolor"/>
</svg>`;
